import React from 'react';
import { CheckIcon, ClockIcon, ShieldCheckIcon, AlertTriangleIcon } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function PricingSection() {
  const handleAddToCart = () => {
    // Track AddToCart event when the user clicks on the purchase button
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Reto de Meditación 30 Días',
        value: 39195.0,
        currency: 'ARS'
      });
    }
  };
  return <section id="pricing" className="py-20 bg-gradient-to-b from-indigo-900 to-purple-900 text-white relative overflow-hidden" data-id="element-239">
      {/* Background image with gradient overlay */}
      <div className="absolute inset-0" data-id="element-240">
        {/* Black gradient overlay behind the image */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 to-black/90 z-0" data-id="element-241"></div>
        {/* Image */}
        <div className="absolute inset-0 opacity-30 z-0" data-id="element-242">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cE53FkXWqXHcsoyBhZFfv8/Generated_Image_September_13%2C_2025_-_2_01AM_%281%29.png" alt="Cosmos background" className="w-full h-full object-cover" data-id="element-243" />
        </div>
      </div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-244">
        <div className="max-w-4xl mx-auto" data-id="element-245">
          
          {/* Added image below heading */}
          <div className="flex justify-center mb-12" data-id="element-246">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4Phfc5NsFUSg7A3kQisU3Z/Generated_Image_September_13%2C_2025_-_2_01AM_%281%29.png" alt="Programa de Meditación Guiada 30 Días" className="w-full max-w-md aspect-square rounded-xl shadow-lg" data-id="element-247" />
          </div>
          <div className="grid md:grid-cols-2 gap-10" data-id="element-248">
            {/* Left column - What's included */}
            <div className="bg-purple-800/80 backdrop-blur-sm p-8 rounded-2xl shadow-xl" data-id="element-249">
              <h3 className="text-2xl font-semibold mb-6 text-center" data-id="element-250">
                El Programa Completo
              </h3>
              <ul className="space-y-4" data-id="element-251">
                <li className="flex items-start" data-id="element-252">
                  <CheckIcon size={20} className="text-purple-300 mr-3 mt-1 flex-shrink-0" data-id="element-253" />
                  <span data-id="element-254">
                    Acceso completo a las 4 sesiones de entrenamiento con
                    frecuencias binaurales específicas
                  </span>
                </li>
                <li className="flex items-start" data-id="element-255">
                  <CheckIcon size={20} className="text-purple-300 mr-3 mt-1 flex-shrink-0" data-id="element-256" />
                  <span data-id="element-257">
                    Manual completo con todos los protocolos y técnicas
                  </span>
                </li>
                <li className="flex items-start" data-id="element-258">
                  <CheckIcon size={20} className="text-purple-300 mr-3 mt-1 flex-shrink-0" data-id="element-259" />
                  <span data-id="element-260">
                    Audios especializados para cada objetivo (abundancia, salud,
                    relaciones)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-261">
                  <CheckIcon size={20} className="text-purple-300 mr-3 mt-1 flex-shrink-0" data-id="element-262" />
                  <span data-id="element-263">
                    Meditaciones guiadas para acceder a estados theta a voluntad
                  </span>
                </li>
                <li className="flex items-start" data-id="element-264">
                  <CheckIcon size={20} className="text-purple-300 mr-3 mt-1 flex-shrink-0" data-id="element-265" />
                  <span data-id="element-266">
                    Bonus exclusivo: Frecuencia "Diamante" para protección
                    energética
                  </span>
                </li>
                <li className="flex items-start" data-id="element-267">
                  <CheckIcon size={20} className="text-purple-300 mr-3 mt-1 flex-shrink-0" data-id="element-268" />
                  <span data-id="element-269">
                    4 Masterclasses adicionales sobre control mental avanzado{' '}
                    <span className="text-yellow-300 font-medium" data-id="element-270">
                      (VALOR: $197)
                    </span>
                  </span>
                </li>
                <li className="flex items-start" data-id="element-271">
                  <CheckIcon size={20} className="text-purple-300 mr-3 mt-1 flex-shrink-0" data-id="element-272" />
                  <span data-id="element-273">
                    Acceso a la comunidad secreta de usuarios{' '}
                    <span className="text-yellow-300 font-medium" data-id="element-274">
                      (VALOR: $97)
                    </span>
                  </span>
                </li>
              </ul>
            </div>
            {/* Right column - Pricing */}
            <div className="bg-indigo-800/80 backdrop-blur-sm p-8 rounded-2xl shadow-xl flex flex-col" data-id="element-275">
              <h3 className="text-2xl font-semibold mb-4 text-center" data-id="element-276">
                OFERTA DE ACCESO EXCLUSIVO
              </h3>
              <div className="text-center mb-6" data-id="element-277">
                <p className="text-gray-300 line-through" data-id="element-278">ARS $78.590,00</p>
                <p className="text-3xl font-bold text-white" data-id="element-279">ARS $39.195,00</p>
                <p className="text-yellow-300 font-medium mt-1" data-id="element-280">
                  BONUS INCLUIDOS
                </p>
              </div>
              <p className="text-center mb-6" data-id="element-281">
                Paga solo ARS $39.195,00 hoy y recibe acceso inmediato a todo el
                programa más los bonos exclusivos.
              </p>
              <a href="https://pay.hotmart.com/W101883420N" target="_blank" rel="noopener noreferrer" className="bg-yellow-500 hover:bg-yellow-400 text-indigo-900 font-bold py-4 px-6 rounded-xl text-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-6 text-center block" onClick={handleAddToCart} data-id="element-282">
                DESCLASIFICAR ACCESO AHORA
              </a>
              <div className="bg-red-500/20 border border-red-400 rounded-lg p-4 mb-6 flex items-center" data-id="element-283">
                <AlertTriangleIcon size={20} className="text-red-300 mr-2 flex-shrink-0" data-id="element-284" />
                <p className="text-red-100 font-medium text-sm" data-id="element-285">
                  OFERTA DISPONIBLE SOLO POR 24 HORAS
                </p>
              </div>
              <div className="flex items-center justify-center mb-6" data-id="element-286">
                <ShieldCheckIcon size={20} className="text-green-300 mr-2" data-id="element-287" />
                <p className="text-green-100" data-id="element-288">
                  Garantía de 7 días - Si no experimentas resultados, te
                  devolvemos el 100% de tu dinero.
                </p>
              </div>
              {/* Countdown timer */}
              <div className="bg-indigo-900/80 rounded-lg p-4 text-center mb-6" data-id="element-289">
                <div className="flex justify-center items-center mb-2" data-id="element-290">
                  <ClockIcon size={18} className="text-yellow-300 mr-2" data-id="element-291" />
                  <span className="text-yellow-300 font-medium" data-id="element-292">
                    Tiempo restante:
                  </span>
                </div>
                <div className="flex justify-center space-x-4 text-2xl font-bold" data-id="element-293">
                  <div className="bg-indigo-950 px-3 py-2 rounded" data-id="element-294">23</div>
                  <div className="text-white" data-id="element-295">:</div>
                  <div className="bg-indigo-950 px-3 py-2 rounded" data-id="element-296">59</div>
                  <div className="text-white" data-id="element-297">:</div>
                  <div className="bg-indigo-950 px-3 py-2 rounded" data-id="element-298">48</div>
                </div>
              </div>
              <p className="text-center text-yellow-200 mt-auto" data-id="element-299">
                Solo 37 accesos disponibles. El sistema cerrará automáticamente
                al completarse.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}